module.exports = require('./helpers/bundle-url').getBundleURL('UckoE') + "down-arrow-1.659ee59e.png" + "?" + Date.now();